export const NAMESPACE = 'eip155'
